const kpiData = [
  {
    id: 'stockout-risk',
    name: 'Stockout Risk',
    category: 'Inventory',
    meaning: 'Identifies SKUs that may run out of stock before the next replenishment cycle.',
    project: 'Power BI Inventory Risk & Replenishment Dashboard',
    formula: 'Current Stock <= Safety Stock OR Forecast Demand > Available Stock',
    action: 'Prioritize replenishment for high-risk SKUs and review demand, lead time, and supplier availability before stock reaches a critical level.',
    tools: ['Power BI', 'Power Query', 'DAX', 'Excel'],
  },
  {
    id: 'reorder-required-skus',
    name: 'Reorder Required SKUs',
    category: 'Inventory',
    meaning: 'Counts products that have reached or fallen below their reorder point.',
    project: 'Inventory Control, Stockout Prevention & Reorder Risk Dashboard',
    formula: 'IF(Current Stock <= Reorder Point, "Reorder Required", "No Action")',
    action: 'Create a reorder priority list and check supplier lead times before issuing purchase requests.',
    tools: ['Excel', 'Power Query', 'Formulas'],
  },
  {
    id: 'inventory-value',
    name: 'Inventory Value',
    category: 'Inventory',
    meaning: 'Measures the total financial value currently tied up in stock.',
    project: 'Power BI Inventory Risk & Replenishment Dashboard',
    formula: 'Inventory Value = Current Stock Quantity x Unit Cost',
    action: 'Review high-value stock, slow-moving items, and overstock exposure to improve working capital control.',
    tools: ['Power BI', 'DAX', 'Excel'],
  },
  {
    id: 'average-lead-time',
    name: 'Average Lead Time',
    category: 'Procurement',
    meaning: 'Shows the average time suppliers take to deliver goods after a purchase order is placed.',
    project: 'Purchase Order Follow-up, PO Aging & Future Supply Risk Dashboard',
    formula: 'Average Lead Time = AVERAGE(Delivery Date - PO Date)',
    action: 'Compare supplier lead time trends and follow up with suppliers that create repeated delivery delays.',
    tools: ['Excel', 'Power Query', 'Pivot Tables'],
  },
  {
    id: 'warehouse-transaction-accuracy',
    name: 'Warehouse Transaction Accuracy',
    category: 'Warehouse',
    meaning: 'Measures how accurately warehouse movements are recorded against expected transactions.',
    project: 'Power BI Inventory Risk & Replenishment Dashboard',
    formula: 'Accuracy % = Accurate Transactions / Total Transactions x 100',
    action: 'Investigate inaccurate transactions, retrain warehouse teams, and improve scanning or documentation controls.',
    tools: ['Power BI', 'Power Query', 'DAX'],
  },
  {
    id: 'damaged-quantity',
    name: 'Damaged Quantity',
    category: 'Warehouse',
    meaning: 'Tracks stock quantities affected by damage during storage, handling, or movement.',
    project: 'Inventory Control, Stockout Prevention & Reorder Risk Dashboard',
    formula: 'Damaged Quantity = SUM(Quantity where Damage Status = "Damaged")',
    action: 'Review handling practices, storage conditions, and supplier packaging quality to reduce avoidable losses.',
    tools: ['Excel', 'Power Query', 'Dashboard Design'],
  },
  {
    id: 'cycle-count-issue-rate',
    name: 'Cycle Count Issue Rate',
    category: 'Warehouse',
    meaning: 'Highlights the percentage of cycle counts with mismatches or inventory accuracy issues.',
    project: 'Power BI Inventory Risk & Replenishment Dashboard',
    formula: 'Issue Rate % = Count Variance Items / Total Counted Items x 100',
    action: 'Investigate high-variance SKUs and improve stock location discipline, counting routines, and transaction controls.',
    tools: ['Power BI', 'DAX', 'Excel'],
  },
  {
    id: 'backorder-quantity',
    name: 'Backorder Quantity',
    category: 'Order Fulfillment',
    meaning: 'Measures customer order quantity that cannot be fulfilled immediately due to insufficient stock.',
    project: 'Inventory Control, Stockout Prevention & Reorder Risk Dashboard',
    formula: 'Backorder Quantity = Ordered Quantity - Fulfilled Quantity',
    action: 'Prioritize supply recovery, communicate expected fulfillment dates, and review reorder planning for repeated backorders.',
    tools: ['Excel', 'Power Query', 'Formulas'],
  },
  {
    id: 'otif-percent',
    name: 'OTIF %',
    category: 'Order Fulfillment',
    meaning: 'Shows the percentage of orders delivered on time and in full.',
    project: 'Power BI Inventory Risk & Replenishment Dashboard',
    formula: 'OTIF % = Orders Delivered On Time and In Full / Total Orders x 100',
    action: 'Analyze late or incomplete deliveries by SKU, supplier, warehouse, and route to improve service reliability.',
    tools: ['Power BI', 'DAX', 'Power Query'],
  },
  {
    id: 'sales-value-at-risk',
    name: 'Sales Value at Risk',
    category: 'Order Fulfillment',
    meaning: 'Estimates potential revenue exposure caused by stockout risk or unfulfilled demand.',
    project: 'Power BI Inventory Risk & Replenishment Dashboard',
    formula: 'Sales Value at Risk = At-Risk Quantity x Selling Price',
    action: 'Escalate high-value risk items, prioritize replenishment, and protect critical customer demand.',
    tools: ['Power BI', 'DAX', 'Excel'],
  },
  {
    id: 'order-fulfillment-rate',
    name: 'Order Fulfillment Rate',
    category: 'Order Fulfillment',
    meaning: 'Measures how much of customer demand is successfully fulfilled from available stock.',
    project: 'Inventory Control, Stockout Prevention & Reorder Risk Dashboard',
    formula: 'Fulfillment Rate % = Fulfilled Quantity / Ordered Quantity x 100',
    action: 'Identify fulfillment gaps and improve stock availability, allocation rules, and replenishment timing.',
    tools: ['Excel', 'Power Query', 'Dashboard Design'],
  },
  {
    id: 'supplier-risk',
    name: 'Supplier Risk',
    category: 'Procurement',
    meaning: 'Flags suppliers that create risk through delays, pending deliveries, or repeated procurement issues.',
    project: 'Purchase Order Follow-up, PO Aging & Future Supply Risk Dashboard',
    formula: 'Supplier Risk = Weighted score of delayed POs, aging days, pending quantity, and supply priority',
    action: 'Follow up with risky suppliers, review alternate sourcing options, and monitor future supply exposure.',
    tools: ['Excel', 'Power Query', 'Pivot Tables'],
  },
];

export default kpiData;
